module.exports = __webpack_public_path__ + "img/logo-daring.5b0fb84a.png";